import React from 'react'

export const None = () => <></>
